export default {
  title: {
    id: 'product_faq_modal_title',
    defaultMessage: 'Frequently asked questions',
  },
}
